import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal, ModalBody, ModalHeader} from 'react-bootstrap'
import {CustomInputs} from '../../../../../../../_metronic/helpers/components/CustomInputs'
import {
  API_URL,
  isMegaPay,
  isNotEmpty,
  KTIcon,
  KTSVG,
  numberWithCommas,
  projectName,
} from '../../../../../../../_metronic/helpers'
import axios from 'axios'
import {OnlinePulse} from '../../../../../accounts/OnlinePulse'
import {Template3Fields} from './Template3Fields'

type props = {
  getNetPrice: () => number
  total: string
  popupHandle: {
    show: boolean
    hide: Dispatch<SetStateAction<boolean>>
  }
  getPrice: () => number
  wage: {
    wage: string
    setWage: Dispatch<SetStateAction<string>>
  }
  profit: {
    profit: string
    setProfit: Dispatch<SetStateAction<string>>
  }
  commission: {
    commission: string
    setCommission: Dispatch<SetStateAction<string>>
  }
  discount: {
    discount: string
    setDiscount: Dispatch<SetStateAction<string>>
  }
  onPercent: {
    onPercent: boolean
    setOnPercent: Dispatch<SetStateAction<boolean>>
  }
}

const DiscountPriceCal: FC<props> = ({
  popupHandle,
  getNetPrice,
  getPrice,
  commission: _commission,
  profit: _profit,
  wage: _wage,
  discount: _discount,
  onPercent,
  total,
}) => {
  const [first, setFirst] = useState(true)
  const [roundedNetPrice, setRoundedNetPrice] = useState(
    isNotEmpty(total) ? Number(total) : getNetPrice()
  )
  const [wage, setWage] = useState<string>(_wage.wage)
  const [profit, setProfit] = useState<string>(_profit.profit)
  const [commission, setCommission] = useState<string>(_commission.commission)
  const [discount, setDiscount] = useState<string>(_discount.discount)
  const [mode, setMode] = useState(0)

  const save = () => {
    onPercent.setOnPercent(false)

    switch (mode) {
      case 0:
        {
          _discount.setDiscount(discount)
        }
        break
      case 1:
        {
          _wage.setWage(wage)
        }
        break
      case 2:
        {
          _profit.setProfit(profit)
        }
        break
      case 3:
        {
          _commission.setCommission(commission)
        }
        break
    }
    setTimeout(() => {
      if (getNetPrice() - roundedNetPrice > 0) {
        switch (mode) {
          case 0:
            {
              setDiscount((Number(discount) - 1).toString())
            }
            break
          case 1:
            {
              setWage((Number(wage) - 1).toString())
            }
            break
          case 2:
            {
              setProfit((Number(profit) - 1).toString())
            }
            break
          case 3:
            {
              setCommission((Number(commission) - 1).toString())
            }
            break
        }
      }
      popupHandle.hide(false)
    }, 10)
  }

  useEffect(() => {
    if (mode === 0 && roundedNetPrice > getNetPrice()) {
      setRoundedNetPrice(getNetPrice())
    }

    let x = getNetPrice() - roundedNetPrice
    x = x / 1.09
    switch (mode) {
      case 0:
        {
          x = Number(_discount.discount) + getNetPrice() - roundedNetPrice
          setDiscount(Math.ceil(x).toString())
        }
        break
      case 1:
        {
          x = Number(_wage.wage) - x
          setWage(Math.ceil(x).toString())
        }
        break
      case 2:
        {
          x = Number(_profit.profit) - x
          setProfit(Math.ceil(x).toString())
        }
        break
      case 3:
        {
          x = Number(_commission.commission) - x
          setCommission(Math.ceil(x).toString())
        }
        break
    }
  }, [roundedNetPrice, mode])

  return (
    <>
      <Modal
        className='fade'
        dialogClassName='mp-invoice-subdialog'
        show
        animation
        id='kt_modal_menu'
        backdrop={true}
        onHide={() => {
          popupHandle.hide(false)
        }}
      >
        <ModalHeader className='px-5 py-3 bg-gray-200'>
          <h2></h2>
          <div
            className='btn btn-sm btn-icon btn-active-color-primary'
            onClick={() => {
              popupHandle.hide(false)
            }}
          >
            <KTIcon className='fs-2x' iconName='cross' />
          </div>
        </ModalHeader>
        <ModalBody>
          <div className='row'>
            <div className='col-12 mt-1'>
              <h2>مبلغ دلخواه خود را تعیین کنید!</h2>
              <p>
                ‌در این قسمت می‌توانید مبلغ نهایی مورد نظر خود را برای این کالا/خدمت وارد کنید.
                {projectName}، تغییرات لازم را اعمال می‌کند تا نهایتا قیمت نهایی این کالا/خدمت به
                مبلغ دلخواه شما برسد.
              </p>
            </div>
            <div className='col-12 mt-5'>
              <CustomInputs
                type={'number'}
                label={'جمع کل کالا/خدمت نهایی'}
                stateValue={{
                  value: roundedNetPrice,
                  setValue: setRoundedNetPrice,
                }}
              />
            </div>
            <div className='col-12 mt-10'>
              باکس مورد نظر خود را از ردیف‌های زیر انتخاب کنید تا {projectName} محاسبه معکوس را در
              آن باکس اعمال کند. سپس با کلیک بر دکمه "اعمال تغییرات"، {projectName} قیمت نهایی را در
              باکس انتخابی شما اعمال خواهد کرد.
            </div>
            <div className='col-12 mt-5'>
              <CustomInputs
                type='radio'
                stateValue={{
                  value: mode,
                  setValue: setMode,
                }}
                isVertical
                items={[
                  // {
                  //   label: 'قیمت پایه',
                  //   value: 4,
                  // },
                  {
                    label: 'تخفیف',
                    value: 0,
                  },
                  {
                    label: 'اجرت ساخت',
                    value: 1,
                  },
                  {
                    label: 'سود فروشنده',
                    value: 2,
                  },
                  {
                    label: 'حق العمل',
                    value: 3,
                  },
                ]}
              />
            </div>
            <div className='col-12 mt-1'>
              {mode == 0 && (
                <CustomInputs
                  type='currency'
                  label='تخفیف'
                  stateValue={{value: discount, setValue: setDiscount}}
                />
              )}
              {/* {mode == 4 && (
                <CustomInputs
                  type='currency'
                  label='قیمت پایه'
                  stateValue={{value: discount, setValue: setDiscount}}
                />
              )} */}
              {mode > 0 && mode < 4 && (
                <div className='row'>
                  <Template3Fields
                    isOneRow
                    percentOf={false}
                    getPrice={getPrice}
                    wage={{
                      wage: wage,
                      setWage: setWage,
                      show: mode == 1,
                    }}
                    commission={{
                      commission: commission,
                      setCommission: setCommission,
                      show: mode == 3,
                    }}
                    profit={{
                      profit: profit,
                      setProfit: setProfit,
                      show: mode == 2,
                    }}
                  />
                </div>
              )}
            </div>
            {/* <div className='col-12 mt-5'>
              <div className='border border-dashed p-5 border-primary rounded bg-light-primary'>
                <div className='text-center fs-4'>
                  جمع کل کالا/خدمت:{' '}
                  <div className='text-primary fw-bolder fs-2 ms-2'>
                    {numberWithCommas(getNetPrice())} ریال
                  </div>
                </div>
              </div>
            </div> */}
            <div className='col-12 mt-5 text-end'>
              <button className='btn btn-success' onClick={save}>
                اعمال تغییرات
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {DiscountPriceCal}
